<template>
    <v-card class="elevation-0">
        <v-toolbar card dense color="transparent">
            <v-toolbar-title><h4>Notification</h4></v-toolbar-title>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
            <v-list two-line class="pa-0">
                <template v-for="(notification, index) in notifications">
                    <v-list-tile avatar :key="'notification--' + index">
                        <v-list-tile-avatar :color="notification.color">
                            <v-icon dark>{{notification.icon}}</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-title>
                            <template v-if="!!fullText">{{notification.message}}</template>
                            <template v-else>{{notification.message.slice(0,25) + '...'}}</template>
                        </v-list-tile-title>
                        <v-list-tile-action class="caption">
                            {{(moment(notification.datetime).fromNow())}}
                        </v-list-tile-action>
                    </v-list-tile>
                </template>
            </v-list>
            <v-divider></v-divider>
            <v-btn v-if="!fullText" block flat class="ma-0" @click="$router.push({name: 'AllNotifications'})">All</v-btn>
            <v-divider></v-divider>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        props: {
            notifications: Array,
            fullText: Boolean
        },
        name: "NotificationList"
    };
</script>
